import { lazy, ComponentType } from "react";

/**
 * Wraps React.lazy() with automatic retry on chunk load failure.
 *
 * After a deployment, old JS chunk filenames become invalid. If a user has the
 * old HTML cached, lazy-loaded chunks will 404. This helper catches that error
 * and reloads the page once (to fetch the new HTML with correct chunk URLs).
 *
 * Uses in-memory flag instead of sessionStorage — sessionStorage is unreliable
 * on Safari Private Browsing / iPad BrowserStack environments.
 */
let reloadAttempted = false;

export function lazyWithRetry<T extends ComponentType<unknown>>(
  factory: () => Promise<{ default: T }>
) {
  return lazy(() =>
    factory().catch((error: unknown) => {
      if (!reloadAttempted) {
        reloadAttempted = true;
        window.location.reload();
        return new Promise<{ default: T }>(() => {});
      }

      throw error;
    })
  );
}
